import React from "react";
import dropColor from "@/assets/logo-drop.png";
import dropWhite from "@/assets/logo-drop-white.png";

export const Logo = ({ variant = "color", withText = true, className = "", imgClassName = "h-10 w-auto" }) => {
  const white = variant === "white";
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <img
        src={white ? dropWhite : dropColor}
        alt="Logo MARTIN NETTOYAGE"
        className={imgClassName}
        loading="eager"
        decoding="async"
      />
      {withText && (
        <span className="flex flex-col leading-none">
          <span
            className={`font-heading font-extrabold text-lg md:text-xl tracking-tight ${
              white ? "text-white" : "text-ink"
            }`}
          >
            MARTIN
          </span>
          <span
            className={`text-[10px] tracking-[0.35em] font-semibold -mt-0.5 ${
              white ? "text-white/60" : "text-muted-foreground"
            }`}
          >
            NETTOYAGE
          </span>
        </span>
      )}
    </span>
  );
};
